import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaExternalLinkAlt } from 'react-icons/fa';
import styles from './Projects.module.css';

const Projects: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const projects = [
    {
      title: 'I-MOBI',
      category: 'PNRR Project',
      description: 'Smart mobility with embedded monitoring.',
      tags: ['IoT', 'Embedded Systems', 'Mobility'],
      color: '#667eea'
    },
    {
      title: 'Self-Healing Composites',
      category: 'Aerospace Research',
      description: 'Self-repairing composites with sensing.',
      tags: ['Materials Science', 'SHM', 'Aerospace'],
      color: '#f093fb'
    },
    {
      title: 'Lava Tube Hazard Analysis',
      category: 'Geospatial AI',
      description: 'AI geological risk modeling.',
      tags: ['AI', 'Geospatial', 'Risk Analysis'],
      color: '#4facfe'
    },
    {
      title: 'Acoustic Emission in AM',
      category: 'Manufacturing Research',
      description: 'AE monitoring for additive manufacturing.',
      tags: ['AE', 'Additive Manufacturing', 'Signal Processing'],
      color: '#f5576c'
    },
    {
      title: 'TexCare CMMS Pro',
      category: 'TexGenia Product',
      description: 'Predictive maintenance for industry.',
      tags: ['AI', 'Predictive Maintenance', 'CMMS'],
      color: '#764ba2'
    }
  ];

  return (
    <section id="projects" className={styles.projects} ref={ref}>
      <div className={styles.container}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className={styles.header}
        >
          <h2 className={styles.title}>Projects</h2>
          <div className={styles.titleUnderline}></div>
        </motion.div>

        <div className={styles.projectsGrid}>
          {projects.map((project, index) => (
            <motion.div
              key={index}
              className={styles.projectCard}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div 
                className={styles.projectHeader} 
                style={{ background: `linear-gradient(135deg, ${project.color} 0%, ${project.color}dd 100%)` }}
              >
                <span className={styles.projectCategory}>{project.category}</span>
              </div>
              
              <div className={styles.projectBody}>
                <h3 className={styles.projectTitle}>{project.title}</h3>
                <p className={styles.projectDescription}>{project.description}</p>
                
                <div className={styles.projectTags}>
                  {project.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className={styles.tag}>{tag}</span>
                  ))}
                </div>

                <button className={styles.projectLink}>
                  Learn More <FaExternalLinkAlt />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
